import { render } from "./TasksPage.vue?vue&type=template&id=aef11ab2&scoped=true"
import script from "./TasksPage.vue?vue&type=script&lang=js"
export * from "./TasksPage.vue?vue&type=script&lang=js"

import "./TasksPage.vue?vue&type=style&index=0&id=aef11ab2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aef11ab2"]])

export default __exports__